import { render, staticRenderFns } from "./EWNewsShow.vue?vue&type=template&id=4743dc4e&"
import script from "./EWNewsShow.vue?vue&type=script&lang=js&"
export * from "./EWNewsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports